import React from 'react';

const TrainingItem = ({ trainingPage, filters, resultSort }) => {
  const className = trainingPage.mark_as_expired
    ? 'single-training is-expired'
    : trainingPage.mark_as_new
      ? 'single-training is-new'
      : 'single-training';

  const markedText = trainingPage.mark_as_expired
    ? I18n.t('training_overview_page.details.marked_expired')
    : trainingPage.mark_as_new
      ? I18n.t('training_overview_page.details.marked_new')
      : '';

  const setCookies = () => {
    const activatedFilters = Object.entries(filters)
      .filter(([key, value]) => value.length > 0)
      .map(([key, value]) => ({ [key]: value }));

    if (resultSort > 0) {
      activatedFilters.push({ resultSort: resultSort });
    }

    if (activatedFilters.length > 0) {
      document.cookie = `allActiveFilters=${JSON.stringify(activatedFilters)}; path=/;`;
    }
  };

  return (
    <li className={className}>
      <a
        href={trainingPage.course_path}
        onClick={setCookies}
        className="training-title"
      >
        <span className="new-teaser">{markedText}</span>
        <span className="training-description">
          <span className="training-learning-format">
            {trainingPage.course_learning_format}
          </span>
          <span className="training-title">
            {trainingPage.title}
            {trainingPage.seminar_title && (
              <span className="subtitle">{trainingPage.seminar_title}</span>
            )}
          </span>
          <span className="training-content">
            {[
              {
                attribute: 'course_professional_group',
                label: I18n.t(
                  'training_overview_page.index.filter.course_professional_group'
                ),
                transform: (value) => value.join(', '),
              },
              {
                attribute: 'course_audience',
                label: I18n.t(
                  'training_page.index.course_audience'
                ),
                transform: (value) => value.join(', '),
              },
            ].map(({ attribute, label, transform }) => {
              const attributeValue = trainingPage[attribute];

              if (attributeValue?.length) {
                return (
                  <span key={attribute}>
                    <span className="areas">{label}:</span>
                    <span>{transform(attributeValue)}</span>
                  </span>
                );
              }

              return null;
            })}
          </span>
        </span>
        <span className="training-details">
          <span className="meta">
            {trainingPage.training_time && (
              <span className="training-date">
                {trainingPage.training_time}
              </span>
            )}
            {trainingPage.sorted_training_sessions_count > 0 && (
              <span className="training-number">
                <span>
                  {trainingPage.sorted_training_sessions_count}{' '}
                  {I18n.t('training_overview_page.index.filter.appointment')}
                </span>
              </span>
            )}
            <span className="training-location" dangerouslySetInnerHTML={{__html: trainingPage.location}}></span>

          </span>
        </span>
      </a>
    </li>
  );
};

export default TrainingItem;
